import React, { Component, Fragment } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { useScroll } from '../../hooks'
import { ContactBarContainer, IconsWrap, ContactItem, TopContentItem, NavAnchor, PopoverContainer } from './atoms'
import { ReactComponent as SkypeIcon } from './images/skype.svg'
import { ReactComponent as EmailIcon } from './images/email.svg'
import { ReactComponent as WhatsAppIcon } from './images/whats_app.svg'
import { ReactComponent as TopIcon } from './images/top.svg'
// import TopIcon from './images/top.png'

function ScrollHandle({ handler }) {
  useScroll(handler)
  return null
}

class ContactBar extends Component {
  state = {
    isLeaveTop: false,
  }
  backToTop = e => {
    const { onClick } = this.props
    e.stopPropagation()
    const result = document.querySelector('main')
    window.location.hash = ''
    result.scrollIntoView()
    if (onClick) {
      onClick()
    }
  }

  handleScroll = e => {
    this.setState({ isLeaveTop: e.target.scrollingElement.scrollTop >= 500 })
  }

  render() {
    let { isLeaveTop } = this.state
    return (
      <Fragment>
        <ContactBarContainer>
          <ScrollHandle handler={this.handleScroll} />

          <IconsWrap>
            <ContactItem>
              <a href='https://wa.me/8618926057801'>
                <WhatsAppIcon />
              </a>
            </ContactItem>
            <ContactItem>
              <a href='skype:live:.cid.cf62d70f1d1215c6?chat'>
                <SkypeIcon />
              </a>
            </ContactItem>
            <ContactItem style={{ overflow: 'visible' }}>
              <EmailIcon />
              <PopoverContainer>
                <div>
                  <NavAnchor
                    style={{ fontSize: 14 }}
                    rel='noopener noreferrer nofollow'
                    href={`mailto:${intl.get('app.contact.email.value')}`}
                    className='nav-anchor'
                  >
                    {`${intl.get('app.footer.contact.email')}: ${intl.get('app.contact.email.value')}`}
                  </NavAnchor>
                </div>
              </PopoverContainer>
            </ContactItem>
          </IconsWrap>

          {isLeaveTop && (
            <IconsWrap style={{ marginTop: '8px' }}>
              <TopContentItem onClick={this.backToTop}>
                <TopIcon />
              </TopContentItem>
            </IconsWrap>
          )}
        </ContactBarContainer>
      </Fragment>
    )
  }
}

ContactBar.propTypes = {
  onClick: PropTypes.func,
}
export default ContactBar
